export default __webpack_public_path__ + "static/O0184-be9ba49baa14c979c642ecb2b62de277.png";